export default __webpack_public_path__ + "static/media/clock.4eec34bd.png";